<template>
    <section id="SecondaryEmail">
        <div v-if="secondary_email && button_secondery && userStatus" class="form-group pl-lg-4">
            <label>{{$t(secondary_email)}}</label>
            <div class="form-control-plaintext">
                <button class="btn btn-primary" data-toggle="modal" data-target="#ModalAddSecondaryEmail">{{$t(button_secondery)}}</button>
            </div>
        </div>
        <div v-else>
            <placeholder-content isLoad="true" />
        </div>
    </section>
</template>
<script>
import PlaceholderContent from '@/plugins/PlaceholderContent.vue'
export default {
    components: {
        PlaceholderContent
    },
    props:['secondary_email', 'button_secondery','userStatus'],
    data() {
        return {
            email: this.secondary_email
        }
    },
    mounted() {
        console.log('secondary', this.email);
    }
}
</script>




// WEBPACK FOOTER //
// src/components/central/account/security/SecondaryEmail.vue